import React, { useCallback, useEffect, useState } from 'react';

import { ENV } from '@environment';
import GoogleMapReact from 'google-map-react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { GoogleMapsWrapper } from 'utils/googlemaps';

import { MapBox } from './styles';

export interface Props {
  show: boolean;
  mapCenter: { lat: number; lng: number };
}

const DEFAULT_ZOOM_VALUE = 16;
const GOOGLE_MAPS_API_KEY = ENV.API_KEYS.GOOGLE_MAPS_API_KEY as string;
let gmapsWrapper: GoogleMapsWrapper;

export const AutoDetailMap = ({ show, mapCenter }: Props) => {
  const { t } = useStoreTranslation();
  const [zoom, setZoom] = useState(DEFAULT_ZOOM_VALUE);
  const [gMapsReady, setGMapsReady] = useState(false);
  const markers: any = [];

  const handleZoomChange = (value: number) => {
    setZoom(value);
  };

  const loadedGoogleApi = useCallback((mapObj, mapsObj) => {
    gmapsWrapper = new GoogleMapsWrapper(mapObj, mapsObj);
    setGMapsReady(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (gMapsReady) {
      const init = async () => {
        const added: any = gmapsWrapper ? await gmapsWrapper.addMarker(mapCenter, () => {}) : null;
        if (added) markers.push(added);
      };
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gMapsReady]);

  return (
    <MapBox isVisible={show}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: GOOGLE_MAPS_API_KEY,
          language: t('locale').substring(0, 2),
          region: t('locale').substring(3),
          libraries: ['places'],
        }}
        defaultCenter={mapCenter}
        defaultZoom={zoom}
        yesIWantToUseGoogleMapApiInternals={true}
        options={{
          fullscreenControl: false,
          zoomControl: false,
        }}
        onZoomAnimationEnd={handleZoomChange}
        onZoomAnimationStart={handleZoomChange}
        onGoogleApiLoaded={({ map, maps }) => loadedGoogleApi(map, maps)}
      />
    </MapBox>
  );
};

export default AutoDetailMap;
